import { strictify } from '~/utils/strictify'
import {
  DashboardQuickActionsSuccessSchema,
  type DashboardQuickActionsSuccess
} from '~/services/api/generated'

export function useDashboardService() {
  const baseURL = `${useRuntimeConfig().public.apiBaseUrl}/api/dashboard`
  const sanctumClient = useApiRequest()

  async function getQuickActions(): Promise<DashboardQuickActionsSuccess> {
    const response = await sanctumClient(`${baseURL}/quick-actions`)
    return strictify(DashboardQuickActionsSuccessSchema).parse(response)
  }

  return { getQuickActions }
}
